import React, {Component, Fragment} from 'react';
import {withTranslation} from 'react-i18next';
import CoursesTranslateDraftView from "../../views/translate/CoursesTranslateDraftView";
import {FlashState, withRouter} from "cw-styleguide-react";
import {Navigate} from "react-router-dom";
import NavigateWithSearch from "../../../../components/NavigateWithSearch";
class CoursesTranslateDraftController extends Component {

  /**
   * componentDidMount.
   */
  componentDidMount() {
    this.props.loadCourse(this.props.params.course);
    this.props.loadAudit(this.props.params.course);
    this.props.clearMessages();
  }

  /**
   * Render.
   * @returns {JSX.Element}
   */
  render() {
    if (this.props.redirect) {
      FlashState.set('flashMessages', this.props.messages);
      return <NavigateWithSearch path={this.props.redirect } />
    }

    return (
      <Fragment>

        <CoursesTranslateDraftView {...this.state} {...this.props}  />
      </Fragment>
    )
  }

}

export default withRouter(withTranslation('local')(CoursesTranslateDraftController));
